import { call, put, takeEvery } from "redux-saga/effects"

// Crypto Redux States
import { ADD_REFERRAL, GET_REFERRAL, UPDATE_REFERRAL } from "./actionTypes"
import {
  addReferralSuccess,
  addReferralFail,
  getReferralSuccess,
  getReferralFail,
  updateReferralSuccess,
  updateReferralFail,
} from "./actions"

//Include Both Helper File with needed methods
import { addReferral,
         getReferral,
         updateReferral} from "helpers/fakebackend_helper"

function* addRef({ payload: referral }) {
  try {
    const response = yield call(addReferral, referral)
    yield put(addReferralSuccess(response))
  } catch (error) {
    yield put(addReferralFail(error))
  }
}

function* getRef({ payload: username }) {
  try {
    const response = yield call(getReferral, username)
    yield put(getReferralSuccess(response))
  } catch (error) {
    yield put(getReferralFail(error))
  }
}
function* updateRef({ payload: referral }) {
  try {
    const response = yield call(updateReferral, referral)
    yield put(updateReferralSuccess(response))
  } catch (error) {
    yield put(updateReferralFail(error))
  }
}

function* referralSaga() {
  yield takeEvery(ADD_REFERRAL, addRef)
  yield takeEvery(GET_REFERRAL, getRef)
  yield takeEvery(UPDATE_REFERRAL, updateRef)

}

export default referralSaga
